/* eslint-disable no-alert */
/* eslint-disable react/jsx-no-bind */
/* eslint-disable @typescript-eslint/no-confusing-void-expression */

import React, { useState } from 'react';

import axios from 'axios';

import {
  ButtonPurple,
  ButtonSend,
  ContainerImageInput,
  ContainerImages,
  ImageStrip,
  Input,
  TextLink,
} from './style';

import strip1PNG from '../../assets/images/youtube-promo/strip-1.png';
import strip2PNG from '../../assets/images/youtube-promo/strip-2.png';
import strip3PNG from '../../assets/images/youtube-promo/strip-3.png';
import strip4PNG from '../../assets/images/youtube-promo/strip-4.png';
import strip5PNG from '../../assets/images/youtube-promo/strip-5.png';

const USERS_BASE_URL = process.env.REACT_APP_USERS_BASE_URL;

export default function YoutubePromo(): JSX.Element {
  const [email, setEmail] = useState('');

  function redirectToStore(): void {
    const userAgent: string = navigator.userAgent || navigator.vendor || (window as any).opera;

    const isAndroid: boolean = /android/i.test(userAgent);
    const isIOS: boolean = /iPad|iPhone|iPod/.test(userAgent) && !(window as any).MSStream;
    const isWindows: boolean = /Win/i.test(userAgent);
    const isMac: boolean = /Mac/i.test(userAgent);

    if (isAndroid || isWindows) {
      window.location.href =
        'https://play.google.com/store/apps/details?id=com.guilu.appresolvaclub';
    } else if (isIOS || isMac) {
      window.location.href =
        'https://apps.apple.com/br/app/resolva-arm%C3%A1rio-digital/id1575252378';
    } else {
      alert(
        'Sistema operacional não identificado. Por favor, acesse a loja de aplicativos manualmente.'
      );
    }
  }

  const handleSend = async (event: React.FormEvent): Promise<void> => {
    event.preventDefault();

    try {
      await axios.post(`${USERS_BASE_URL}check-subscriptions/insert-username-for-youtoube-promo`, {
        username: email,
      });

      alert('Tudo certo! Agora se cadastre no app com este mesmo email e aproveite os benefícios!');
    } catch (e) {
      if (e.response.data.sqlMessage.includes('Duplicate entry')) {
        alert('Email já registrado na promoção! Utilize outro email para prosseguir');
      } else {
        alert(
          `Ocorreu um erro ao registrar seu email. Por favor contate a central através do whatsapp: +55 (11) 93400-9574. ${e.response.data}`
        );
      }
    }
  };

  return (
    <ContainerImages>
      <ImageStrip src={strip1PNG} />
      <form onSubmit={handleSend}>
        <ContainerImageInput style={{ position: 'relative' }}>
          <ImageStrip src={strip2PNG} />
          <Input
            placeholder="E-mail"
            value={email}
            onChange={(event) => setEmail(event.target.value)}
            type="email"
            required
          />
          <ButtonSend type="submit">Enviar</ButtonSend>
        </ContainerImageInput>
      </form>
      <ContainerImageInput style={{ position: 'relative' }}>
        <ImageStrip src={strip3PNG} />
        <ButtonPurple bottom="750px" onClick={redirectToStore}>
          Clique aqui!
        </ButtonPurple>
      </ContainerImageInput>
      <ContainerImageInput style={{ position: 'relative' }}>
        <ImageStrip src={strip4PNG} />
        <ButtonPurple bottom="80px" onClick={redirectToStore}>
          Baixe agora!
        </ButtonPurple>
      </ContainerImageInput>
      <ContainerImageInput style={{ position: 'relative' }}>
        <ImageStrip src={strip5PNG} />
        <TextLink>https://resolva-app-web-pages.vercel.app/redirect-to-store</TextLink>
      </ContainerImageInput>
    </ContainerImages>
  );
}
